import { render } from "./RouteCard.vue?vue&type=template&id=18923937&scoped=true"
import script from "./RouteCard.vue?vue&type=script&lang=js"
export * from "./RouteCard.vue?vue&type=script&lang=js"

import "./RouteCard.vue?vue&type=style&index=0&id=18923937&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18923937"]])

export default __exports__